import { post } from "@/utils/utils";
// 导购相关接口
const smsManagement = {
  state: {},
  mutations: {
    QUERY_STORE_MSG_NUM() {},
    QUERY_STORE_MSG_CONFIG() {},
    SMS_RECHARGE() {},
    QUERY_SMS_NAME() {},
    BATCH_SEND_MSG() {},
    QUERY_STORE_MSG_RECHARGE_LISt() {},
    QUERY_ALL_STORE_MSG_RECHARGE_LISt() {},
    BATCH_SEND_MSG_TARGET_ACCOUNT() {}
  },
  actions: {
    queryStoreMessageNum({ commit }, params) {
      return post({
        commit,
        url: `/sms/config/queryStoreMessageNum`,
        name: "QUERY_STORE_MSG_NUM",
        params
      });
    },
    queryStoreSmsConfigList({ commit }, params) {
      return post({
        commit,
        url: `/sms/config/queryStoreSmsConfigList`,
        name: "QUERY_STORE_MSG_CONFIG",
        params
      });
    },
    smsRecharge({ commit }, params) {
      return post({
        commit,
        url: `/sms/config/smsRecharge`,
        name: "SMS_RECHARGE",
        params
      });
    },
    querySmsSignature({ commit }, params) {
      return post({
        commit,
        url: `/sms/config/querySmsSignature`,
        name: "QUERY_SMS_NAME",
        params
      });
    },
    batchSendMessage({ commit }, params) {
      return post({
        commit,
        url: `sms/config/batchSendMessage`,
        name: "BATCH_SEND_MSG",
        params
      });
    },
    batchSendMessageTargetAccount({ commit }, params) {
      return post({
        commit,
        url: `sms/config/batchSendMessageTargetAccout`,
        name: "BATCH_SEND_MSG_TARGET_ACCOUNT",
        params
      });
    },
    queryStoreSmsSendRecordList({ commit }, params) {
      return post({
        commit,
        url: `sms/config/queryStoreSmsSendRecordList`,
        name: "QUERY_STORE_MSG_RECHARGE_LISt",
        params
      });
    },
    queryAllStoreSmsSendRecordList({ commit }, params) {
      return post({
        commit,
        url: `sms/config/queryStoreSmsSendRecordList`,
        name: "QUERY_ALL_STORE_MSG_RECHARGE_LISt",
        params
      });
    }
  }
};

export default smsManagement;
